import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Users, BookOpen, Shield, Globe } from 'lucide-react';
export function OtlVisor() {
  return <div className="mb-24" data-id="element-346">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-12" data-id="element-347">
        <div className="lg:col-span-5" data-id="element-348">
          <h3 className="font-serif text-3xl md:text-4xl text-forest mb-6" data-id="element-349">
            Visor de OTL
          </h3>
          <div className="space-y-4 text-charcoal/80 font-light leading-relaxed" data-id="element-350">
            <p data-id="element-351">
              El Visor de OTL es una herramienta digital que permite consultar
              en un mapa los diez objetos territoriales legales priorizados por
              el Ministerio de Ambiente. A través del visor, cualquier usuario
              puede identificar dónde se ubican estas figuras, cuáles son sus
              límites y qué información básica está asociada a ellas.
            </p>
            <p data-id="element-352">
              Es una plataforma geográfica digital donde puedes consultar y
              visualizar en el mapa los diez objetos territoriales legales que
              el Ministerio de Ambiente ha priorizado. Allí puedes ver la
              ubicación exacta, los límites y las características de cada figura
              territorial.
            </p>
          </div>
        </div>
        <div className="lg:col-span-7" data-id="element-353">
          <h4 className="font-serif text-xl text-forest mb-6" data-id="element-354">
            ¿Para quién es útil?
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-355">
            <div className="flex gap-4" data-id="element-356">
              <Shield className="text-clay flex-none mt-1" size={24} strokeWidth={1.5} data-id="element-357" />
              <div data-id="element-358">
                <strong className="block text-charcoal font-medium mb-1 text-sm" data-id="element-359">
                  Entidades públicas
                </strong>
                <p className="text-charcoal/70 text-sm font-light leading-relaxed" data-id="element-360">
                  Que necesitan tomar decisiones basadas en información
                  territorial oficial.
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-361">
              <BookOpen className="text-clay flex-none mt-1" size={24} strokeWidth={1.5} data-id="element-362" />
              <div data-id="element-363">
                <strong className="block text-charcoal font-medium mb-1 text-sm" data-id="element-364">
                  Investigadores y academia
                </strong>
                <p className="text-charcoal/70 text-sm font-light leading-relaxed" data-id="element-365">
                  Que estudian el ambiente y el ordenamiento del territorio.
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-366">
              <Users className="text-clay flex-none mt-1" size={24} strokeWidth={1.5} data-id="element-367" />
              <div data-id="element-368">
                <strong className="block text-charcoal font-medium mb-1 text-sm" data-id="element-369">
                  Organizaciones sociales
                </strong>
                <p className="text-charcoal/70 text-sm font-light leading-relaxed" data-id="element-370">
                  Y comunitarias que trabajan en la defensa de sus territorios.
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-371">
              <Globe className="text-clay flex-none mt-1" size={24} strokeWidth={1.5} data-id="element-372" />
              <div data-id="element-373">
                <strong className="block text-charcoal font-medium mb-1 text-sm" data-id="element-374">
                  Ciudadanía en general
                </strong>
                <p className="text-charcoal/70 text-sm font-light leading-relaxed" data-id="element-375">
                  Que quiere entender qué tipo de protección existe en un lugar
                  del país.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-50px'
    }} transition={{
      duration: 0.7
    }} className="relative w-full h-[480px] md:h-[680px] bg-forest overflow-hidden mb-12" data-id="element-376">
        <iframe title="Visor de OTL — ArcGIS Experience" src="https://experience.arcgis.com/experience/2b40477aad324361a7fd7603c1eb873d" className="absolute inset-0 w-full h-full" style={{
        border: 'none'
      }} allowFullScreen loading="lazy" data-id="element-377" />
      </motion.div>

      <div className="max-w-4xl mx-auto text-center space-y-4 text-charcoal/80 font-light leading-relaxed text-lg" data-id="element-378">
        <p data-id="element-379">
          El Visor no requiere conocimientos técnicos especializados: cualquier
          persona puede navegar por el mapa, identificar las figuras
          territoriales y acceder a información oficial de forma directa.
        </p>
        <p data-id="element-380">
          Los OTL son una forma de hacer más visible, comprensible y útil la
          información ambiental del territorio. Al organizar esta información en
          un lenguaje común, contribuyen a que las instituciones trabajen de
          manera más coordinada y a que la ciudadanía pueda conocer mejor las
          reglas, valores y responsabilidades asociadas a los lugares donde
          vive, trabaja o desarrolla sus actividades.
        </p>
        <p className="font-serif text-2xl text-forest mt-8" data-id="element-381">
          Con los OTL, el territorio no solo se observa en un mapa: se entiende
          mejor, se administra con mayor claridad y se protege con mejores
          herramientas.
        </p>
      </div>
    </div>;
}